import React from "react";

import { Props } from "./types";
import { CasForm } from "./casForm";
import { AzureForm } from "./azureForm";
import { FormTypeSelect } from "./formTypeSelect";
import styles from "./styles.scss";

function Form({ formData, edit }: Props) {
  return (
    <div className={styles.identityProvider}>
      <div className={styles.header}>
        <FormTypeSelect
          type={formData.name}
          select={(name) =>
            edit({
              ...formData,
              name,
              config:
                name === "azure"
                  ? {
                      scope: "openid,email,profile,offline_access",
                    }
                  : {},
            })
          }
        />
      </div>
      <div className={styles.main}>
        {formData.name === "cas" ? (
          <CasForm
            identityProvider={formData}
            edit={edit}
            remove={console.log}
          />
        ) : (
          formData.name === "azure" && (
            <AzureForm
              identityProvider={formData}
              edit={edit}
              remove={console.log}
            />
          )
        )}
      </div>
    </div>
  );
}

export { Form };
